import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Building2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

const FIELDS = [["workshop_phone", "workshopPhone", "ltr"], ["workshop_address", "workshopAddress", "auto"], ["workshop_cr", "workshopCr", "ltr"]];

export const WorkshopInfoDialog = () => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ workshop_phone: "", workshop_address: "", workshop_cr: "" });

  useEffect(() => {
    if (open) api.get("/settings").then(({ data }) => setForm({ workshop_phone: data.workshop_phone, workshop_address: data.workshop_address, workshop_cr: data.workshop_cr }));
  }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.put("/settings", form); toast.success(t("success")); setOpen(false); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><Button variant="outline" data-testid="workshop-info-btn"><Building2 className="w-4 h-4" />{t("workshopInfo")}</Button></DialogTrigger>
      <DialogContent data-testid="workshop-info-dialog">
        <DialogHeader>
          <DialogTitle>{t("workshopInfo")}</DialogTitle>
          <DialogDescription>{t("workshopInfoHint")}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          {FIELDS.map(([k, l, dir]) => (
            <div key={k} className="space-y-1.5"><Label>{t(l)}</Label>
              <Input dir={dir} data-testid={`workshop-${k}-input`} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} /></div>
          ))}
          <DialogFooter><Button type="submit" data-testid="workshop-info-save">{t("save")}</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
